/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api 
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { BillingProcessStatus } from './billingProcessStatus';


export interface ServiceTransactionLogDtos { 
    transactionId?: string;
    serviceId?: string;
    clientId?: string;
    operationCount: number;
    channel?: string;
    transactionTimeStamp: Date;
    service?: string;
    status: BillingProcessStatus;
    billingTaskInterval: number;
    retriesCount: number;
    firstTransactionTimeStamp: Date;
    lastTransactionTimeStamp: Date;
    grpcServerUrl?: string;
    anqUserId: number;
}
